import React, { useState } from 'react';
import axios from 'axios';

const ActicationPWG = () => {
  const [formData, setFormData] = useState({
    esn: '',
    planId: '',
    language: 'SPAN',
    zip: '',
    billingCode: '',
    e911Address: {
      street1: 'XYZ',
      street2: 'XYZ',
      city: 'XYZ',
      state: 'XYZ',
      zip: '94105'
    }
  });

  const [plans] = useState([
    { id: '01', name: '1 GB 30 Days' },
    { id: '02', name: '2.5 GB 30 Days' },
    { id: '03', name: '5 GB 30 Days' },
    { id: '04', name: '7.5 GB 30 Days' },
    { id: '05', name: '10 GB 30 Days' },
    { id: '06', name: '15 GB 30 Days' },
    { id: '07', name: '20 GB 30 Days' },
    { id: '08', name: '1 GB 30 Days' },
    { id: '09', name: '2.5 GB 30 Days' }
  ]);

  const [billingCodes] = useState(['GIG3','GIG625','GIG12', 'GIG175', 'GIG23', 'GIG34', 'GIG45']);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      e911Address: {
        ...prev.e911Address,
        [name]: value
      }
    }));
  };

  const validateForm = () => {
    if (!formData.esn.trim()) return 'ESN is required';
    if (!formData.planId) return 'Please select a plan';
    if (!formData.zip.trim()) return 'Zipcode is required';
    if (!formData.billingCode) return 'Please select a billing code';
    if (!formData.e911Address.street1.trim() || 
        !formData.e911Address.city.trim() || 
        !formData.e911Address.state.trim() || 
        !formData.e911Address.zip.trim()) {
      return 'Complete E911 address information is required';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);

    try {
      const requestPayload = {
        request: {
          type: "Activate",
          esn: formData.esn,
          planId: formData.planId,
          language: formData.language,
          zip: formData.zip,
          billingCode: formData.billingCode,
          e911Address: formData.e911Address
        }
      };

      const response = await axios.post(
        'https://pwg.clay.in/api/Pwg/ActivateEsnSim',
        requestPayload,
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          },
          timeout: 30000
        }
      );

      if (response.data.success) {
        setMessage('eSIM activated successfully!');
        setFormData({
          esn: '',
          planId: '',
          language: 'en',
          zip: '',
          billingCode: '',
          e911Address: {
            street1: '',
            street2: '',
            city: '',
            state: '',
            zip: ''
          }
        });
      } else {
        setError(`Activation failed: ${response.data?.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('API Error:', err);
      
      if (err.response) {
        if (err.response.status === 500) {
          setError(`Server Error: ${err.response.data?.message || 'Internal server error occurred'}`);
        } else {
          setError(`HTTP Error: ${err.response.status} - ${err.response.statusText}`);
        }
      } else if (err.request) {
        setError('Network Error: Unable to connect to server. Please check your connection.');
      } else {
        setError(`Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

 

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          {/* Header */}
          <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="mb-4 sm:mb-0">
              <h1 className="text-2xl font-bold text-gray-800">eSIM Activation</h1>
              <p className="text-sm text-gray-500 mt-1">Activate your eSIM with plan and billing details</p>
            </div>
            
          </div>

          {/* Alert Messages */}
          {message && (
            <div className="mx-6 mt-6 p-4 bg-green-50 border border-green-200 text-green-700 rounded-lg flex items-start">
              <svg className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="text-sm font-medium">{message}</span>
            </div>
          )}
          
          {error && (
            <div className="mx-6 mt-6 p-4 bg-red-50 border border-red-200 text-red-700 rounded-lg flex items-start">
              <svg className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
              <span className="text-sm font-medium">{error}</span>
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-6">
            {/* Basic Information Section */}
            <div className="mb-8">
              <h2 className="text-lg font-semibold text-gray-800 mb-4">Basic Information</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* ESN Field */}
                <div>
                  <label htmlFor="esn" className="block text-sm font-medium text-gray-700 mb-2">
                    eSIM/ESN <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="esn"
                    name="esn"
                    value={formData.esn}
                    onChange={handleInputChange}
                    placeholder="Enter eSIM/ESN"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  />
                </div>

                {/* Zipcode Field */}
                <div>
                  <label htmlFor="zip" className="block text-sm font-medium text-gray-700 mb-2">
                    Zipcode <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="zip"
                    name="zip"
                    value={formData.zip}
                    onChange={handleInputChange}
                    placeholder="Enter zipcode"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  />
                </div>

                {/* Plan Selection */}
                <div>
                  <label htmlFor="planId" className="block text-sm font-medium text-gray-700 mb-2">
                    Select Plan <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="planId"
                    name="planId"
                    value={formData.planId}
                    onChange={handleInputChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white"
                  >
                    <option value="">Select plan ID</option>
                    {plans.map(plan => (
                      <option key={plan.id} value={plan.id}>
                        ({plan.id}) {plan.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Billing Code Selection */}
                <div>
                  <label htmlFor="billingCode" className="block text-sm font-medium text-gray-700 mb-2">
                    PWG Cost Plan <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="billingCode"
                    name="billingCode"
                    value={formData.billingCode}
                    onChange={handleInputChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white"
                  >
                    <option value="">Select billing code</option>
                    {billingCodes.map(code => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Language Selection */}
                <div className="md:col-span-2">
                  <label htmlFor="language" className="block text-sm font-medium text-gray-700 mb-2">
                    Language
                  </label>
                  <select
                    id="language"
                    name="language"
                    value={formData.language}
                    onChange={handleInputChange}
                    className="w-full md:w-1/2 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white"
                  >
                    <option value="SPAN">English</option>
                    <option value="SPAN">Spanish</option>
                  </select>
                </div>
              </div>
            </div>

           

            {/* Submit Button */}
            <div className="mt-8 flex justify-end space-x-4">
             
              <button 
                type="submit" 
                disabled={loading}
                className="px-6 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
              >
                {loading && (
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                )}
                {loading ? 'Activating...' : 'Activate eSIM'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ActicationPWG;
